// 运营
import { AREA_DIR } from '../../const/area';
import * as TYPES from './action-types';

export default {
	namespaced: true,
	state: {
		areas: [],
		currentArea: null,
		currentAreaIndex: -1,
		areaPickerList: [],
		isDefaultAreaLoaded: false
	},
	getters: {
		areas: state => state.areas,
		currentArea: state => state.currentArea,
		currentAreaId: state => {
			let {id} = state.currentArea || {};
			return id;
		},
		currentAreaName: state => {
			let {name} = state.currentArea || {};
			return name;
		},
		currentAreaIndex: state => state.currentAreaIndex,
		currentAreaPriceList: state => {
			let {priceList = []} = state.currentArea || {};
			return priceList || [];
		},
		areaPickerList: state => state.areaPickerList,
		isDefaultAreaLoaded: state => state.isDefaultAreaLoaded,
		// 枢纽站模式相关原始参数
		hubAreaInfo: state => {
			const { hubAreaInfo } = state.currentArea || {};
			return hubAreaInfo
		},
		// 是否枢纽站模式
		isHubArea: state => {
			const { isHubArea } = state.currentArea || {};
			return isHubArea
		},
		// 是否预约单
		isBookingTicket: state => {
			const { isBookingTicket } = state.currentArea || {};
			return isBookingTicket
		},
		// 是否从枢纽站出发
		isFromHub: state => {
			const { hubAreaInfo } = state.currentArea || {};
			const { direction } = hubAreaInfo || {};
			return direction === AREA_DIR.FROM_HUB;
		},
		// 是否存在反方向
		isReversedExist: state => {
			const { isReversedExist } = state.currentArea || {};
			return isReversedExist || false;
		},
		// 预下单时间段
		preTimeList: state => {
			const { preTimeList } = state.currentArea || {};
			return preTimeList || []
		},
		// 枢纽站点
		hubStops: state => {
			const { hubStops } = state.currentArea || {};
			return hubStops || []
		},
	},
	mutations: {
		[TYPES.RUN__SET_AREAS](state, payload) {
			state.areas = payload;
		},
		[TYPES.RUN__ADD_AREA](state, payload) {
			state.areas = state.areas.concat(payload);
		},
		[TYPES.RUN__SET_CURRENT_AREA](state, payload) {
			state.currentArea = payload;
		},
		[TYPES.RUN__SET_CURRENT_AREA_INDEX](state, payload) {
			state.currentAreaIndex = payload;
		},
		[TYPES.RUN__SET_AREA_PICKER_LIST](state, payload) {
			state.areaPickerList = payload;
		},
		setDefaultAreaState(state, payload) {
			state.isDefaultAreaLoaded = payload;
		}
	},
	actions: {
		[TYPES.RUN__SET_AREAS]({commit}, payload) {
			commit(TYPES.RUN__SET_AREAS, payload);
		},
		[TYPES.RUN__ADD_AREA]({commit}, payload) {
			commit(TYPES.RUN__ADD_AREA, payload);
		},
		[TYPES.RUN__SET_CURRENT_AREA]({commit}, payload) {
			commit(TYPES.RUN__SET_CURRENT_AREA, payload);
		},
		[TYPES.RUN__SET_CURRENT_AREA_INDEX]({commit}, payload) {
			commit(TYPES.RUN__SET_CURRENT_AREA_INDEX, payload);
		},
		[TYPES.RUN__SET_AREA_PICKER_LIST]({commit}, payload) {
			commit(TYPES.RUN__SET_AREA_PICKER_LIST, payload);
		},
		setDefaultAreaState({commit}, payload) {
			commit('setDefaultAreaState', payload);
		}
	}
};
